import { Component } from '@angular/core';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent {
  public isAccepted: boolean = false;
  public isForm: boolean = false;

  termAccepted($event: Event) {
    // @ts-ignore
    this.isAccepted = $event.target.checked;
  }

  setIsForm() {
    this.isForm = true;
  }
}
